const sidecontrol = document.querySelector(".sidecontrol");

if (sidecontrol) {
    function scrollSidecontrol() {
        if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 200) {
            sidecontrol.classList.add('show');
        } else {
            sidecontrol.classList.remove('show');
        }
    }

    window.addEventListener('scroll', scrollSidecontrol);


    const sidecontrolBtn = document.querySelector(".sidecontrol-totop");
    sidecontrolBtn.addEventListener("click", function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

    const sidecontrolShare = document.querySelector(".sidecontrol-share button");

    sidecontrolShare.addEventListener("click", function () {
        if (sidecontrolShare.getAttribute("aria-pressed") === "false") {
            sidecontrolShare.setAttribute("aria-pressed", "true");
            sidecontrolShare.nextElementSibling.setAttribute("aria-hidden", "false");
        } else {
            sidecontrolShare.setAttribute("aria-pressed", "false");
            sidecontrolShare.nextElementSibling.setAttribute("aria-hidden", "true");
        }
    });



}